import axios from "axios";

export const API = axios.create({
  baseURL: "https://annexacapitaladmin-api.skyapi.store/",
  // baseURL: "http://localhost:1821/",
});
